import {AfterViewInit, Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {CodeInputComponent as LibCodeInputComponent} from 'angular-code-input';

@Component({
    selector: 'ui-kit-code-input',
    templateUrl: 'code-input.component.html',
    standalone: false,
})
export class CodeInputComponent implements AfterViewInit {
    @ViewChild('inner', {static: true}) inner!: LibCodeInputComponent;

    @Input() codeLength!: number;
    @Input() inputType?: string;
    @Input() inputMode?: string;
    @Input() initialFocusField?: number;
    @Input() isNonDigitsCode = false;
    @Input() isCharsCode!: boolean;
    @Input() isCodeHidden!: boolean;
    @Input() isPrevFocusableAfterClearing!: boolean;
    @Input() isFocusingOnLastByClickIfFilled!: boolean;
    @Input() code?: string | number;
    @Input() disabled!: boolean;
    @Input() autocapitalize?: string;

    @Output() readonly codeChanged = new EventEmitter<string>();
    @Output() readonly codeCompleted = new EventEmitter<string>();


    ngAfterViewInit(): void {
        this.preventIMEFalseBackspace();
    }

    reset(isChangesEmitting?: boolean): void {
        this.inner.reset(isChangesEmitting);
    }

    focusOnField(index: number): void {
        this.inner.focusOnField(index);
    }

    private preventIMEFalseBackspace(): void {
        const inputs = this.inner.inputsList;
        inputs.forEach((inputRef: any) => {
            const el = inputRef?.nativeElement;
            el?.addEventListener(
                'keydown',
                (e: any) => {
                    const isIOSChinese =
                        /iPad|iPhone|iPod/.test(navigator.userAgent) &&
                        navigator.language.startsWith('zh');
                    const isIME = e.keyCode === 229;
                    if (isIOSChinese && isIME) {
                        e.stopImmediatePropagation();
                    }
                },
                true,
            );
        });
    }
}
